import Dict from '@/utils/dict-utils'

// 文档类型
export const jxicDocTypeDict = new Dict({
  PLATFORM_NOTICE: { label: '采购平台制度', value: 1 },
  PURCHASE_MANAGEMENT: { label: '招标采购制度', value: 2 },
  DOCUMENT: { label: '采购其他资料', value: 3 }
})

// 采购其他资料类型
export const jxicOtherDocTypeDict = new Dict({
  PROJECT: { label: '采购项目资料', value: 1 },
  OTHER: { label: '其他资料', value: 2 }
})

// 采购其他资料类型
export const isDeletedDict = new Dict({
  NO: { label: '否', value: 0 },
  YES: { label: '是', value: 1 }
})

// 采购报告类型
export const purchaseReportDict = new Dict({
  MONTHLY: { label: '月报', value: 1 },
  QUARTERLY: { label: '季报', value: 2 },
  FIRST_HALF_YEARLY: { label: '上半年报', value: 3 },
  SECOND_HALF_YEARLY: { label: '下半年报', value: 4 },
  YEARLY: { label: '年报', value: 5 }
})
